import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '91视频在线观看需要付费吗？',
    answer: '完全不需要！91视频始终坚持免费播放的原则，所有视频资源均可免费在线观看，无需会员、无需付费。我们通过技术优化降低运营成本，让每一位用户都能享受高品质的视频服务。',
  },
  {
    question: '视频画质怎么样？支持哪些清晰度？',
    answer: '我们提供从流畅（360P）到超高清4K的多种清晰度选择，用户可根据网络状况和设备性能自由切换。平台采用先进的H.265编码技术，在相同码率下提供更清晰的画质，同时节省流量。',
  },
  {
    question: '可以在手机上观看吗？需要下载APP吗？',
    answer: '91视频完美适配手机、平板、电脑等多种设备，无需下载任何APP或插件，直接通过浏览器即可流畅观看。我们采用响应式设计，无论在iOS、Android还是Windows、Mac系统上都有出色的播放体验。',
  },
  {
    question: '视频加载速度慢怎么办？',
    answer: '91视频采用自研的P2P-CDN混合加速技术，在全国部署了超过500个CDN节点。如果遇到加载慢的情况，建议尝试切换清晰度或刷新页面。大部分用户在4G网络下即可实现秒开播放。',
  },
  {
    question: '平台上的视频资源更新频率如何？',
    answer: '我们的内容团队每天24小时不间断更新，热门影视剧在播出后2小时内即可上线，综艺节目当天更新，确保您第一时间看到最新内容。同时，我们也会根据用户反馈优先更新热门资源。',
  },
  {
    question: '如何反馈意见或报告问题？',
    answer: '您可以通过"关于我们"页面的联系表单提交反馈，或直接发送邮件至service@91video.com。我们的客服团队会在24小时内回复您的每一条反馈。您的声音对我们非常重要！',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-14 md:py-20 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-1">关于91视频，你可能想了解的一切</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === index ? 'bg-primary-100 text-primary-600 rotate-180' : 'bg-background-100 text-foreground-500'
                  }`}>
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}